module.exports = __webpack_public_path__ + "static/media/track-bg-front-layer-one@2x.2b439ce0.png";